import { Alert } from '@mui/material';
import { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { translate } from 'react-switch-lang';
import { Button, Card, CardBody, CardHeader, Col, Container, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import { useHttpClient } from 'src/security/hooks/axiosProvider';
import SweetAlert from 'sweetalert2';
import Breadcrumb from '../../breadcrumb/index';
import styles from '../../styles/style-setting.module.scss';
import CreateDevise from './CreateDevise';
import DetailDevise from './DetailDevise';
import DeviseColumns from './DeviseColumns';
import EditDevise from './EditDevise';

const NUMBER_OF_DEVISE_PER_PAGE = 15;

const CurrencyPage = (props) => {
  const { devise, setDevise: setDeviseState } = useDevise();

  const { updateDeviseById, createDevise, deleteDevise } = useMutateDevise();
  const [search, setSearch] = useState('');
  const [itemOffset, setItemOffset] = useState(0);
  const [currentDevise, setCurrentDevise] = useState<Devise | null>(null);

  const [isOpen, setIsOpen] = useState(false);

  const [isOpenEdit, setIsOpenEdit] = useState(false);

  const filteredDevise = devise.filter(
    (devise) => devise.name.toLowerCase().includes(search) || devise.code.toLowerCase().includes(search)
  );

  const endOffset = itemOffset + NUMBER_OF_DEVISE_PER_PAGE;
  const pageCount = Math.ceil(filteredDevise.length / NUMBER_OF_DEVISE_PER_PAGE);
  const currentItems = filteredDevise.slice(itemOffset, endOffset);

  const handleSearch = (event) => {
    const { value } = event.target;
    setSearch(value.toLowerCase());
  };

  const handlePageClick = (event) => {
    const newOffset = (event.selected * NUMBER_OF_DEVISE_PER_PAGE) % filteredDevise.length;
    setItemOffset(newOffset);
  };

  const onEdit = (devise) => {
    setCurrentDevise(devise);
    setIsOpenEdit(true);
  };
  const onDelete = async (devise) => {
    const result = await SweetAlert.fire({
      title: props.t('you_delete'),
      text: props.t('not_recover'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, supprimez-le!',
      cancelButtonText: props.t('cancel'),
    });

    if (result.isConfirmed) {
      const { id } = devise;

      const response = await deleteDevise(id);

      if (response?.status === 204) {
        setDeviseState((prevState) => prevState.filter((devise) => devise.id !== id));
        SweetAlert.fire(props.t('deleted'), props.t('devise_deleted'), 'success');
      } else {
        SweetAlert.fire(props.t('error'), props.t('err'), 'error');
      }
    }
  };
  const onDetail = (devise) => {
    setIsOpen(true);
    setCurrentDevise(devise);
  };

  useEffect(() => {
    if (!isOpenEdit) {
      setCurrentDevise(null);
    }
  }, [isOpenEdit]);

  return (
    <>
      <div>
        <Breadcrumb parent={props.t('devise')} url={'settings/currency'} />
        <Container fluid={true}>
          <Row>
            <Col sm="12">
              <Card>
                <CardHeader>
                  <div className="float-right">
                    <CreateDevise devises={devise} setDeviseState={setDeviseState} createDevise={createDevise} />
                  </div>
                </CardHeader>
                <CardBody>
                  <input
                    onChange={handleSearch}
                    className="form-control col-md-6 mb-2"
                    placeholder={props.t('search_unit')}
                  />
                  {currentItems.length === 0 ? (
                    <Alert variant="outlined" severity="info">
                      {props.t('no_devise')}
                    </Alert>
                  ) : (
                    <DeviseColumns onEdit={onEdit} onDelete={onDelete} onDetail={onDetail} data={currentItems} />
                  )}

                  <br />
                  <div className="float-right">
                    {devise.length > NUMBER_OF_DEVISE_PER_PAGE && (
                      <ReactPaginate
                        previousLabel="<"
                        nextLabel=">"
                        pageCount={pageCount}
                        onPageChange={handlePageClick}
                        containerClassName={styles['paginationButton']}
                        previousLinkClassName={styles['previousBtn']}
                        nextLinkClassName={styles['nextBtn']}
                        disabledClassName={styles['paginationDisabled']}
                        activeClassName={styles['paginationActive']}
                      />
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      {/* model for details */}
      <Modal isOpen={isOpen} toggle={() => setIsOpen(false)} centered>
        <ModalHeader>{props.t('detail_devise')}</ModalHeader>
        <ModalBody>
          <DetailDevise devise={currentDevise} />
          <div>
            <Button color="secondary" className="float-right" onClick={() => setIsOpen(false)}>
              {props.t('Cancel')}
            </Button>
          </div>
        </ModalBody>
      </Modal>

      {/* model for edit */}
      {currentDevise && (
        <EditDevise
          setDeviseState={setDeviseState}
          updateDeviseById={updateDeviseById}
          isOpen={isOpenEdit}
          setIsOpen={setIsOpenEdit}
          devise={currentDevise}
          devises={devise}
        />
      )}
    </>
  );
};

interface Devise {
  id: number;
  name: string;
  code: string;
}

export const useDevise = () => {
  const httpClient = useHttpClient();
  const [devise, setDevise] = useState<Devise[]>([]);

  useEffect(() => {
    const fetch = async () => {
      const reposnse = await httpClient.current?.get(`/api/devises`);
      setDevise(reposnse.data);
    };

    fetch();
  }, [httpClient]);

  return {
    devise,
    setDevise,
  };
};

const useMutateDevise = () => {
  const httpClient = useHttpClient();

  const updateDeviseById = async (id: number, data: Devise) => {
    const response = await httpClient.current?.put(`/api/devises/${id}`, data);
    return response;
  };

  const createDevise = async (data: Devise) => {
    const response = await httpClient.current?.post(`/api/devises`, data);
    return response;
  };

  const deleteDevise = async (id: number) => {
    const response = await httpClient.current?.delete(`/api/devises/${id}`);
    return response;
  };

  return {
    updateDeviseById,
    createDevise,
    deleteDevise,
  };
};

export default translate(CurrencyPage);
